import { registerSuccessHandle, loginSuccessHandle } from "./AccountEvent";
export var EVENT2URL;
(function (EVENT2URL) {
  EVENT2URL["registerSuccess"] = "/api/user/v1/accounts/email";
  EVENT2URL["googleLoginSuccess"] = "/api/user/v1/accounts/google/login";
  EVENT2URL["phoneLoginSuccess"] = "/api/user/v1/accounts/phone/login";
})(EVENT2URL || (EVENT2URL = {}));
export var EVENT3URL;
(function (EVENT3URL) {
  EVENT3URL["loginSuccess"] = "/api/user/v1/accounts/email/login";
  EVENT3URL["googleLoginSuccess"] = "/api/user/v1/accounts/google/login";
  EVENT3URL["phoneLoginSuccess"] = "/api/user/v1/accounts/phone/login";
})(EVENT3URL || (EVENT3URL = {}));
export var EVENT4URL;
(function (EVENT4URL) {
  EVENT4URL["generateSuccess"] = "/api/resources/v1/images/test";
  EVENT4URL["generateSuccess2"] = "/api/resources/v1/images/generate";
})(EVENT4URL || (EVENT4URL = {}));
/**
 * [统一处理 非业务代码事件]
 * 1. 数据埋点
 * 2. 百度回传
 * 3. 谷歌回传
 * ......
 */
export const nonBusinessEventTracker = res => {
  const {
    config,
    data
  } = res;
  const {
    url = ""
  } = config;
  // 处理其他类型的接口
  switch (url) {
    case "/api/user/v1/accounts/google/login":
    case "/api/user/v1/accounts/phone/login":
      var _data_data;
      if (!(data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.register)) break; //非注册事件，则返回
      registerSuccessHandle(data);
      break;
    case "/api/user/v1/accounts/email":
      registerSuccessHandle(data);
      break;
    default:
      break;
  }
  switch (url) {
    case "/api/user/v1/accounts/google/login":
    case "/api/user/v1/accounts/phone/login":
      var _data_data1;
      if ((data === null || data === void 0 ? void 0 : (_data_data1 = data.data) === null || _data_data1 === void 0 ? void 0 : _data_data1.register) !== false) break; //未注册或非登录事件，则返回
      loginSuccessHandle(data);
      break;
    case "/api/user/v1/accounts/email/login":
      var _data_data2;
      if ((data === null || data === void 0 ? void 0 : (_data_data2 = data.data) === null || _data_data2 === void 0 ? void 0 : _data_data2.code) === 110008) break; //如果未注册，直接返回
      loginSuccessHandle(data);
      break;
    default:
      break;
  }
};